import axios from 'axios';

import { store } from '../store'

import config  from '../libs/config.json'



class Service {
  constructor() {
    //console.log('JWT', localStorage.getItem('jwt'), 'agaa');
  }


  async get(path, payload) {
    let service = await axios.create({
      headers: {
          'Authorization': 'Bearer '+ store.getters['session/getJwt']
        }
    });
    try {
        const response = await service.request({
          method: 'GET',
          url: config.url + path,
          responseType: 'json',
          data: payload
        })
        return response.data;
  
      } catch (error) {
      console.log(error)
      return error;
      }
    }

  delete(path, callback) {
    let service = axios.create({
      headers: {
          'Authorization': 'Bearer '+ store.getters['session/getJwt']
        }
  });
    return service.delete(config.url + path).then(
      (response) => callback(null, response.data)).catch(function(error) {
        if (error.response) {
          if((error.response.data && error.response.data.message == 'jwt expired') || (error.response.data && error.response.data.message == 'jwt malformed')){
            localStorage.setItem('jwt', '');
            window.location.href = '/logout'
          }
              // that falls out of the range of 2xx
              callback(error.response, null)
            } else if (error.request) {
              // The request was made but no response was received
              console.log(error.request);
              callback(error.request, null)
            } else {
              // Something happened in setting up the request that triggered an Error
              console.log('Error', error.message);
              callback(error.message, null)
            }
      });
  }

  async put(path, payload) {
  let service = await axios.create({
    headers: {
        'Authorization': 'Bearer '+ store.getters['session/getJwt']
      }
  });
  try {
      const response = await service.request({
        method: 'PUT',
        url: config.url + path,
        responseType: 'json',
        data: payload
      })
      const res = response.data;
      return res;

    } catch (error) {
    console.log(error)
    return error;
    }
  }

  async postFormData(path, payload) {
    let service = await axios.create({
      headers: {
          'Authorization': 'Bearer '+ store.getters['session/getJwt'],
          'Content-Type': 'multipart/form-data'
        }
  });
  try {
      const response = await service.request({
        method: 'POST',
        url: config.url + path,
        responseType: 'json',
        data: payload
      });
      const data = response.data;
      return { err: null, data };
    } catch (error) {
      return { err: error.response.data, data: null };
    }
  }

  post(path, payload, callback) {
    let service = axios.create({
      headers: {
          'Authorization': 'Bearer '+ store.getters['session/getJwt']
        }
  });
    return service.request({
      method: 'POST',
      url: config.url + path,
      responseType: 'json',
      data: payload
    }).then((response) => callback(null, response.data, response)).catch(function(error) {
        if (error.response) {
          if((error.response.data && error.response.data.message == 'jwt expired') || (error.response.data && error.response.data.message == 'jwt malformed')){
            localStorage.setItem('jwt', '');
            window.location.href = '/logout'
          }
              // that falls out of the range of 2xx
              callback(error.response, null)
            } else if (error.request) {
              // The request was made but no response was received
              console.log(error.request);
              callback(error.request, null)
            } else {
              // Something happened in setting up the request that triggered an Error
              console.log('Error', error.message);
              callback(error.message, null)
            }
      });
  }

      head(path, callback) {
        let service = axios.create({
          headers: {
              'Authorization': 'Bearer '+ store.getters['session/getJwt']
            }
      });
        return service.request({
          method: 'HEAD',
          url: config.url + path,
          responseType: 'json'
        }).then((response) => callback(null, response)).catch(function(error) {
          if (error.response) {
            if((error.response.data && error.response.data.message == 'jwt expired') || (error.response.data && error.response.data.message == 'jwt malformed')){
              localStorage.setItem('jwt', '');
              window.location.href = '/logout'
            }
                // that falls out of the range of 2xx
                callback(error.response, null)
              } else if (error.request) {
                // The request was made but no response was received
                console.log(error.request);
                callback(error.request, null)
              } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
                callback(error.message, null)
              }
        });
      }
}

export default new Service;


// WEBPACK FOOTER //
// ./src/api/async.js